import {
  FormGroup as MuiFormGroup,
  RadioGroupProps as MuiRadioGroupProps,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
} from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { RadioOption } from "./RadioGroup";
import { Grid, RichTextReader, Stack } from "@compass/core";

export type CheckBoxGroupProps = MuiRadioGroupProps & {
  label?: string;
  required?: boolean;
  values: number[];
  isDisabled: boolean;
  onChange: (value: number, isChecked: boolean) => any;
  onOtherChange: (value: any, otherValue: string) => any;
  options: RadioOption[];
};

export const CheckboxGroup = ({
  label,
  isDisabled,
  required,
  values,
  options,
  onChange,
  onOtherChange,
}: CheckBoxGroupProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(parseInt(event.target.value), event.target.checked);
  };

  const handleOtherChange = (option: RadioOption, otherValue: string) => {
    option.isOtherValue = otherValue;
    onOtherChange(option.value, option.isOtherValue);
  };

  return (
    <FormControl required={required || false}>
      {label && <FormLabel id={label}>{label}</FormLabel>}

      {options.length <= 12 && (
        <MuiFormGroup>
          {options.map((o, index) => (
            <Stack key={index} direction="row">
              <FormControlLabel
                disabled={isDisabled}
                key={index}
                value={o.value}
                control={
                  <Checkbox checked={values.includes(o.value as number)} onChange={handleChange} name={o.label} />
                }
                label={<RichTextReader html={o.label} />}
              />
              {o.isOther && values.includes(o.value as number) && (
                <Input
                  style={{ marginTop: 0 }}
                  placeholder=""
                  disabled={isDisabled}
                  value={o.isOtherValue}
                  onChange={(e) => {
                    handleOtherChange(o, e.target.value);
                  }}
                />
              )}
            </Stack>
          ))}
        </MuiFormGroup>
      )}
      {options.length > 12 && (
        <MuiFormGroup>
          <Grid container>
            {options.map((o, index) => (
              <Grid item xs={6} key={index}>
                <Stack key={index} direction="row">
                  <FormControlLabel
                    disabled={isDisabled}
                    key={index}
                    value={o.value}
                    control={
                      <Checkbox checked={values.includes(o.value as number)} onChange={handleChange} name={o.label} />
                    }
                    label={<RichTextReader html={o.label} />}
                  />
                  {o.isOther && values.includes(o.value as number) && (
                    <Input
                      style={{ marginTop: 0 }}
                      placeholder=""
                      disabled={isDisabled}
                      value={o.isOtherValue}
                      onChange={(e) => {
                        handleOtherChange(o, e.target.value);
                      }}
                    />
                  )}
                </Stack>
              </Grid>
            ))}
          </Grid>
        </MuiFormGroup>
      )}
    </FormControl>
  );
};
